<template>
  <div class="section">
    <groups
      :groups="faqGroups"
      :selected-group="selectedGroup"
      @group-selected="setSelectedGroup"
    />
    <div
      v-for="faq in selectedGroupFAQs"
      :key="faq.Id"
    >
      <faq
        :faq="faq"
        :selected-faq="selectedFaq"
        @faq-selected="setSelectedFaq"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Groups from './components/Groups'
import Faq from './components/Faq'

export default {
  components: {
    Faq,
    Groups
  },
  data () {
    return {
      faqQuestionAnswers: window.pageData.homeFaq.faqQuestionAnswers,
      selectedGroup: null,
      selectedFaq: null
    }
  },
  computed: {
    faqGroups () {
      return _(this.faqQuestionAnswers)
        .map(f => { return f.Group })
        .uniqBy(g => { return g.Id })
        .sortBy(g => { return g.SortOrder })
        .value()
    },
    selectedGroupFAQs () {
      if (this.selectedGroup === null) return []

      return _(this.faqQuestionAnswers)
        .filter(f => { return f.Group.Id === this.selectedGroup.Id })
        .sortBy(f => { return f.SortOrder })
        .value()
    }
  },
  watch: {
    selectedGroupFAQs (v) { // sets the first question as selected/visible when a group is selected
      if (v.length > 0) {
        this.selectedFaq = _(v).first()
      }
    }
  },
  mounted () {
    this.selectedGroup = this.faqGroups[0]
  },
  methods: {
    setSelectedGroup (group) {
      this.selectedGroup = group
    },
    setSelectedFaq (faq) {
      this.selectedFaq = faq
    }
  }
}
</script>



// WEBPACK FOOTER //
// WebResources/vue/pictureday/home/faq/App.vue